<template>
  <div class="footer">
    <div class="footer__copyright">Copyright &copy; {{ year }} Fuel Medical Group. All rights reserved.</div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    computed: {
      year() {
        return (new Date()).getFullYear();
      },
    },
  };
</script>
